<template>
  <ToastLayer :isOpen="isOpen" :text="text" />
</template>

<script>
import ToastLayer from '@/presentationals/v2/components/layouts/templates/ToastLayer'

export default {
  name: 'ToastLayerContainer',
  components: {
    ToastLayer
  },
  computed: {
    text() {
      return this.$store.getters['toast/text']
    },
    isOpen() {
      return this.$store.getters['toast/isOpen']
    }
  }
}
</script>